import React from "react";
import { Link, useLocation } from "react-router-dom";
import { Home, Activity, Plus, Gift, User } from "lucide-react";

const items = [
  { to: "/home", label: "Home", icon: Home, testid: "nav-home" },
  { to: "/progress", label: "Progress", icon: Activity, testid: "nav-progress" },
  { to: "/action", label: "", icon: Plus, testid: "nav-action", center: true },
  { to: "/rewards", label: "Rewards", icon: Gift, testid: "nav-rewards" },
  { to: "/profile", label: "Profile", icon: User, testid: "nav-profile" },
];

export default function BottomNav() {
  const { pathname } = useLocation();
  return (
    <nav
      className="fixed bottom-0 inset-x-0 mx-auto max-w-md backdrop-blur-xl bg-[#0a1822]/85 border-t border-[#1a2f40] z-30"
      data-testid="bottom-nav"
    >
      <div className="flex items-center justify-around px-2 py-2">
        {items.map((it) => {
          const Icon = it.icon;
          const active = pathname === it.to || (it.to === "/home" && pathname === "/home");
          if (it.center) {
            return (
              <Link
                key={it.to}
                to={it.to}
                data-testid={it.testid}
                className="-mt-7 w-14 h-14 rounded-full bg-[#2fbf71] text-[#0a1822] flex items-center justify-center shadow-lg shadow-[#2fbf71]/30"
                aria-label="Action center"
              >
                <Icon size={26} strokeWidth={2.5} />
              </Link>
            );
          }
          return (
            <Link
              key={it.to}
              to={it.to}
              data-testid={it.testid}
              className={`flex flex-col items-center gap-1 px-3 py-2 rounded-xl transition-colors ${
                active ? "text-[#2fbf71]" : "text-slate-400 hover:text-white"
              }`}
            >
              <Icon size={22} strokeWidth={active ? 2.4 : 2} />
              <span className="text-[11px] font-medium">{it.label}</span>
            </Link>
          );
        })}
      </div>
    </nav>
  );
}
